import { render, staticRenderFns } from "./ChatSection.vue?vue&type=template&id=64634e4e&scoped=true&"
import script from "./ChatSection.vue?vue&type=script&lang=ts&"
export * from "./ChatSection.vue?vue&type=script&lang=ts&"
import style0 from "./ChatSection.vue?vue&type=style&index=0&id=64634e4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64634e4e",
  null
  
)

export default component.exports